import { SizableText, YStack } from '@mythical/ui'
import { Perk } from 'app/queries/perks/perks'
import { Tier } from 'app/queries/tiers/member-tiers'

import { Container } from 'app/components/structure/Container'
import { MarketingHeading } from 'app/features/landing/components'
import { TierCard } from './TiersCard'

type SubscriptionPanelProps = {
  title?: string
  subtitle?: string
  memberTiers?: (Tier & { description: string })[]
  perks?: Perk[]
}

const SubscriptionPanel = ({
  title,
  subtitle,
  memberTiers = [],
  perks = [],
}: SubscriptionPanelProps) => {
  if (!memberTiers.length) {
    return null
  }

  const sortedTiers = [...memberTiers].sort((a, b) => a.planLevel - b.planLevel)

  return (
    <Container gap="$8" variant="full">
      <Container ai="center" gap="$3.5" $gtSm={{ gap: '$5' }} variant="full">
        {title && <MarketingHeading tag="h2">{title}</MarketingHeading>}
        {!!subtitle && (
          <SizableText
            ff="$title"
            size="$m"
            ta="center"
            $gtSm={{ size: '$xl' }}
          >
            {subtitle}
          </SizableText>
        )}
      </Container>

      <YStack gap="$4" w="100%" $gtMd={{ fd: 'row', gap: '$5' }}>
        {sortedTiers.map((tier) => (
          <TierCard key={tier.id} tier={tier} perks={perks} displayGiftLink />
        ))}
      </YStack>
    </Container>
  )
}

export default SubscriptionPanel
